import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import NtTextInput from "../../../components/NtTextInput";
import colors from "../../../config/colors";

function NtSectionInputField({
  containerStyle,
  icon,
  title,
  footer,
  placeholder,
  value,
  setValue,
  titleStyle,
  inputStyle,
  renderAction,
  renderSuggestions,
  showEye = false,
  ...otherProps
}) {
  return (
    <View style={[styles.container, containerStyle]}>
      <NtText
        style={[styles.title, { marginLeft: 4, marginBottom: 4 }, titleStyle]}
      >
        {title}
      </NtText>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <NtTextInput
          showEye={showEye}
          icon={icon}
          textStyle={{ flex: 1 }}
          textColor="white"
          containerStyle={[styles.input, inputStyle]}
          placeholder={placeholder}
          placeholderTextColor={"#e8e8e8"}
          value={value}
          autoCorrect={false}
          autoCapitalize="none"
          onChangeText={(text) => setValue(text)}
          renderAction={renderAction}
          {...otherProps}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
  title: {
    fontSize: 14,
    fontWeight: "700",
    color: "white",
  },
  footer: {
    fontSize: 11,
    fontWeight: "600",
    color: colors.lighGray,
    fontStyle: "italic",
  },
  input: {
    paddingLeft: 10,
    paddingRight: 10,
    height: 45,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    borderRadius: 6,
  },
});

export default NtSectionInputField;
